import React from "react";
import Bio from "components/bio";
import Layout from "components/layout";
import SEO from "components/seo";
var HomeIndex = function HomeIndex(_ref) {
    var data = _ref.data, location = _ref.location;
    var siteTitle = data.site.siteMetadata.title;
    return /*#__PURE__*/ React.createElement(Layout, {
        location: location,
        title: siteTitle
    }, /*#__PURE__*/ React.createElement(SEO, {
        title: "Home"
    }), /*#__PURE__*/ React.createElement(Bio, null));
};
export var pageQuery = "3263961146";
export default HomeIndex;
